<script>

export default {
    name: "OfficeAccessList",
    data() {
        return {
            userId: null,
            loading: false,
            campuses: [],
            campusAccess: [],
            duAccess: [],
            departmentAccess: [],
            selectedCampus: null,
            selectedDU: null,
            search: "",
            currentPage: 1,
            itemsPerPage: 15
        };
    },
    computed: {
        filteredCampuses() {
            let data = this.campuses;
            if (this.search.trim() != "" && this.search != null) {
                data = data.filter((item) => {
                    return item.campusName
                        .toUpperCase()
                        .includes(this.search.toUpperCase());
                });
            }
            var total = this.currentPage * this.itemsPerPage;
            var currentData = data.slice(total - this.itemsPerPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.itemsPerPage;
                currentData = data.slice(total - this.itemsPerPage, total);
            }
            return currentData;
        },  
        campusRows() {
            let data = this.campuses;
            if (this.search.trim() != "" && this.search != null) {
                data = data.filter((item) => {
                    return item.campusName
                        .toUpperCase()
                        .includes(this.search.toUpperCase());
                });
            }
            return data.length;
        },
        filteredDUs() {
            if(!this.selectedCampus) return [];
            let data = this.selectedCampus.dus;
            if (this.selectedCampus.search.trim() != "" && this.selectedCampus.search != null) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.selectedCampus.search.toUpperCase());
                });
            }
            var total = this.selectedCampus.currentPage * this.itemsPerPage;
            var currentData = data.slice(total - this.itemsPerPage, total);
            if (this.selectedCampus.currentPage > 1 && currentData.length == 0) {
                total = (this.selectedCampus.currentPage - 1) * this.itemsPerPage;
                currentData = data.slice(total - this.itemsPerPage, total);
            }
            return currentData;
        },
        duRows() {
            if(!this.selectedCampus) return 0;
            let data = this.selectedCampus.dus;
            if (this.selectedCampus.search.trim() != "" && this.selectedCampus.search != null) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.selectedCampus.search.toUpperCase());
                });
            }
            return data.length;
        },
        filteredDepartments() {
            if(!this.selectedDU) return [];
            let data = this.selectedDU.departments;
            if (this.selectedDU.search.trim() != "" && this.selectedDU.search != null) {
                data = data.filter((item) => {
                    return item.departmentName
                        .toUpperCase()
                        .includes(this.selectedDU.search.toUpperCase());
                });
            }
            var total = this.selectedDU.currentPage * this.itemsPerPage;
            var currentData = data.slice(total - this.itemsPerPage, total);
            if (this.selectedDU.currentPage > 1 && currentData.length == 0) {
                total = (this.selectedDU.currentPage - 1) * this.itemsPerPage;
                currentData = data.slice(total - this.itemsPerPage, total);
            }
            return currentData;
        },
        departmentRows() {
            if(!this.selectedDU) return 0;
            let data = this.selectedDU.departments;
            if (this.selectedDU.search.trim() != "" && this.selectedDU.search != null) {
                data = data.filter((item) => {
                    return item.departmentName
                        .toUpperCase()
                        .includes(this.selectedDU.search.toUpperCase());
                });
            }
            return data.length;
        }
    },
    methods: {
        async getData(id){
            this.userId = id;
            this.loading = true;
            this.campuses = [];
            this.duAccess = [];
            this.departmentAccess = [];
            this.selectedCampus = null;
            await this.getAllCampus();
            await this.getCampusAccess(id);
            await this.getDUAccess(id);
            await this.getDepartmentAccess(id);
            this.loading = false;
        },
        async getAllCampus() {
            try{
                const { data : response } = await this.$store.dispatch("campus/GetCampus");
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map((x) => {
                    x.accessId = 0;
                    x.checkMe = false;
                    x.loadingDus = false;
                    x.dus = [];
                    x.search = "";
                    x.currentPage = 1;
                });
                this.campuses = response;
            }catch(err) {
                this.showToast("Something went wrong - getting campuses!", "error");
            }
        },
        async getCampusAccess(id) {
            try{
                const { data : response } = await this.$store.dispatch("campusaccess/GetCampusAccess", id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.campusAccess = JSON.parse(JSON.stringify(response));
                this.campuses.forEach((campus) => {
                    const access = response.find((x) => x.campusId === campus.id);
                    if (access) {
                        campus.checkMe = true;
                        campus.accessId = access.id;
                    }
                });
            }catch(err) {
                this.showToast("Something went wrong - getting campus access!", "error");
            }
        },
        async getDUAccess(id) {
            try{
                const { data : response } = await this.$store.dispatch("deliveryUnitAccess/getUsersDeliveryUnitAccess", id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.duAccess = response;
            }catch(err) {
                this.showToast("Something went wrong - getting delivery unit access!", "error");
            }
        },
        async viewDUs(campus){
            this.selectedCampus = campus;
            if(campus.dus.length > 0) return;
            campus.loadingDus = true;
            try{
                const { data : response } = await this.$store.dispatch("deliveryunit/GetDeliveryUnitByCampus", campus.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map((x) => {
                    let check = this.duAccess.find(du => du.id == x.id);
                    x.accessId = check ? check.id : 0;
                    x.checkMe = !!check;
                    x.checkHide = check ? !check.withDeliveryUnitAccess : false;
                    x.loadingDepartments = false;
                    x.departments = [];
                    x.search = "";
                    x.currentPage = 1;
                });
                campus.dus = response;
            }catch(err) {
                this.showToast("Something went wrong - getting campuses!", "error");
            }
            campus.loadingDus = false;
        },
        async getDepartmentAccess(id) {
            try{
                const { data : response } = await this.$store.dispatch("departmentAccess/getUsersDepartmentAccess", id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.departmentAccess = response;
            }catch(err) {
                this.showToast("Something went wrong - getting department access!", "error");
            }
        },
        async viewDepartments(du){
            this.selectedDU = du;
            if(du.departments.length > 0) return;
            du.loadingDepartments = true;
            try{
                const { data : response } = await this.$store.dispatch("department/GetDepartmentByDU", du.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map((x) => {
                    let check = this.departmentAccess.find(department => department.departmentId == x.id);
                    x.accessId = check ? check.id : 0;
                    x.checkMe = !!check;
                });
                du.departments = response;
            }catch(err) {
                this.showToast("Something went wrong - getting campuses!", "error");
            }
            du.loadingDepartments = false;
        },
        async saveSelectedCampus(campusIds){
            let errors = [];
            for await (const campusId of campusIds) {
                let campusAccess = this.campusAccess.find(access => access.campusId == campusId);
                if(campusAccess) continue;
                try{
                    const { data : response } = await this.$store.dispatch(
                        "campusaccess/CreateCampusAccess", 
                        { applicationUserId: this.userId, campusId }
                    );
                    if(response.error){
                        errors.push(response.errorMessage);
                    }
                }catch(err) {
                    errors.push("Something went wrong - adding campus access!");
                }
            }
            return errors;
        },
        async deleteSelectedCampus(accessIds){
            let errors = [];
            for await (const accessId of accessIds) {
                try{
                    const { data : response } = await this.$store.dispatch(
                        "campusaccess/DeleteCampusAccess", 
                        accessId
                    );
                    if(response.error){
                        errors.push(response.errorMessage);
                    }
                }catch(err) {
                    errors.push("Something went wrong - removing campus access!");
                }
            }
            return errors;
        },
        async saveSelectedDU(dus){
            let errors = [];
            try{
                const { data : response } = await this.$store.dispatch(
                    "deliveryUnitAccess/addUsersDeliveryUnitAccess", 
                    { 
                        applicationUserId: this.userId, 
                        access: dus.map(du => ({ deliveryUnitId: du.id, withDeliveryUnitAccess: du.withDeliveryUnitAccess }))
                    }
                );
                if(response.error){
                    errors.push(response.errorMessage);
                }
            }catch(err) {
                errors.push("Something went wrong - adding delivery unit access!");
            }
            return errors;
        },
        async deleteSelectedDU(accessIds){
            let errors = [];
            for await (const accessId of accessIds) {
                try{
                    const { data : response } = await this.$store.dispatch(
                        "deliveryUnitAccess/removeDeliveryUnitAccess", 
                        accessId
                    );
                    if(response.error){
                        errors.push(response.errorMessage);
                    }
                }catch(err) {
                    errors.push("Something went wrong - removing delivery unit access!");
                }
            }
            return errors;
        },
        async saveSelectedDepartment(departmentIds){
            let errors = [];
            try{
                const { data : response } = await this.$store.dispatch(
                    "departmentAccess/addUsersDepartmentAccess", 
                    { 
                        applicationUserId: this.userId, 
                        access: departmentIds.map(departmentId => ({ id: departmentId}))
                    }
                );
                if(response.error){
                    errors.push(response.errorMessage);
                }
            }catch(err) {
                errors.push("Something went wrong - adding department access!");
            }
            return errors;
        },
        isTheSame({accessList, selectedIds, reference}){
            let accIds = accessList.map(access => access[reference]);
            return JSON.stringify(accIds) == JSON.stringify(selectedIds);
        },
        async submitAccess(){
            this.pageLoader(true);
            let selectedCampus = [];
            let deletedCampus = [];
            let selectedDU = [];
            let deletedDU = [];
            let selectedDepartment = [];
            let deletedDepartment = [];
            this.campuses.map((campus) => {
                if(campus.checkMe){
                    selectedCampus.push(campus.id);
                }
                if(!campus.checkMe && campus.accessId > 0){
                    deletedCampus.push(campus.accessId);
                }
                campus.dus.forEach((du) => {
                    if(du.checkMe){
                        selectedDU.push({id: du.id, withDeliveryUnitAccess: du.checkHide ? false : true});
                    }
                    if(!du.checkMe && du.accessId > 0){
                        deletedDU.push(du.accessId);
                    }
                    du.departments.forEach((department) => {
                        if(department.checkMe){
                            selectedDepartment.push(department.id);
                        }
                        if(!department.checkMe && department.accessId > 0){
                            deletedDepartment.push(department.accessId);
                        }
                    });
                });
            });
            this.duAccess.map(du => {
                let findDUFromSelected = selectedDU.find(item => item.id == du.id);
                let findDUFromDeleted = deletedDU.find(id => id == du.id);
                if(!findDUFromSelected && !findDUFromDeleted){
                    selectedDU.push({id: du.id, withDeliveryUnitAccess: du.withDeliveryUnitAccess });
                }
            });
            this.departmentAccess.map(department => {
                let findDepartmentFromSelected = selectedDepartment.find(id => id == department.departmentId);
                let findDepartmentFromDeleted = deletedDepartment.find(id => id == department.departmentId);
                if(!findDepartmentFromSelected && !findDepartmentFromDeleted){
                    selectedDepartment.push(department.departmentId);
                }
            });
            let errors = [];
            if(selectedCampus.length > 0 && !this.isTheSame({accessList: this.campusAccess, selectedIds: selectedCampus, reference: 'campusId'})){
                let campusErrors = await this.saveSelectedCampus(selectedCampus);
                errors = errors.concat(campusErrors);
            }
            if(deletedCampus.length > 0){
                let campusErrors = await this.deleteSelectedCampus(deletedCampus);
                errors = errors.concat(campusErrors);
            }
            if(selectedDU.length > 0 && !this.isTheSame({accessList: this.duAccess, selectedIds: selectedDU, reference: 'id'})){
                let duErrors = await this.saveSelectedDU(selectedDU);
                errors = errors.concat(duErrors);
            }
            if(selectedDepartment.length > 0 && !this.isTheSame({accessList: this.departmentAccess, selectedIds: selectedDepartment, reference: 'departmentId'})){
                let departmentErrors = await this.saveSelectedDepartment(selectedDepartment);
                errors = errors.concat(departmentErrors);
            }
            this.pageLoader(false);
            if(errors.length > 0){
                this.showToast("Some access could not be updated!", "error");
            }else{
                this.showToast("Office access successfully updated!", "success");
                this.$bvModal.hide("office-access-modal");
            }
        }
    }
};
</script>
<template>
    <b-modal
        id="office-access-modal"
        :title="`Office Access List`"
        size="xxl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row border-bottom">
            <div class="col-md-4 border-end">
                <div class="d-flex justify-content-between mb-2">
                    <p class="mb-0 text-white font-weight-bold font-size-18">
                        {{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }} Access
                    </p>
                    <input 
                        type="text" 
                        class="form-control form-control-sm w-auto" 
                        :placeholder="`Search ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" 
                        v-model="search"
                    />
                </div>
                <template v-if="loading">
                    <div class="text-center my-5 py-5">
                        <div class="py-5 my-5">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="ps-2 border-bottom">
                        <div v-for="item in filteredCampuses" :key="item.id" class="mb-1">
                            <div
                                class="
                                    form-check form-checkbox-outline form-check-success
                                    mb-0
                                "
                            >
                                <input
                                    type="checkbox"
                                    :id="`customCheckcolor${item.id}`"
                                    v-model="item.checkMe"
                                    class="form-check-input"
                                />
                                <label
                                    :for="`customCheckcolor${item.id}`"
                                    class="form-check-label d-flex align-items-center"
                                >
                                    <span :class="{'text-info font-weight-bold': selectedCampus && item.id == selectedCampus.id}">{{ item.campusName }}</span>
                                    <a 
                                        href="javascript:void(0);" 
                                        class="mb-0 line-height-1" 
                                        title="View Delivery Unit Access"
                                        @click.stop="viewDUs(item)"
                                    >
                                        <i class="bx bx-chevron-right font-size-20"></i>
                                    </a>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="dataTables_paginate paging_simple_numbers float-end py-2">
                        <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="campusRows"
                                :per-page="itemsPerPage"
                                size="sm"
                            ></b-pagination>
                        </ul>
                    </div>
                </template>
            </div>
            <div class="col-md-4 border-end">
                <div class="d-flex justify-content-between mb-2">
                    <p class="mb-0 text-white font-weight-bold font-size-18">
                        Delivery Unit Access
                    </p>
                    <input 
                        v-if="selectedCampus"
                        type="text" 
                        class="form-control form-control-sm w-auto" 
                        placeholder="Search Delivery Unit..." 
                        v-model="selectedCampus.search"
                    />
                </div>
                <template v-if="selectedCampus">
                    <template v-if="selectedCampus.loadingDus">
                        <div class="text-center my-5 py-5">
                            <div class="py-5 my-5">
                                <b-spinner variant="primary" label="Loading..."></b-spinner>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="ps-2 border-bottom">
                            <div v-for="item in filteredDUs" :key="item.id" class="mb-1">
                                <div class="d-flex justify-content-between">
                                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                                        <input
                                            type="checkbox"
                                            :id="`customCheckcolor${item.id}`"
                                            v-model="item.checkMe"
                                            class="form-check-input"
                                        />
                                        <label
                                            :for="`customCheckcolor${item.id}`"
                                            class="form-check-label d-inline"
                                        >
                                            <span :class="{'text-info font-weight-bold': selectedDU && item.id == selectedDU.id}">{{ item.name }}</span>
                                            <a 
                                                href="javascript:void(0);" 
                                                class="mb-0 line-height-1" 
                                                title="View Delivery Unit Access"
                                                @click.stop="viewDepartments(item)"
                                                :style="{verticalAlign: 'middle'}"
                                            >
                                                <i class="bx bx-chevron-right font-size-20"></i>
                                            </a>
                                        </label>
                                    </div>
                                    <div class="form-check form-checkbox-outline form-check-success mb-0" v-if="selectedDU && item.id == selectedDU.id">
                                        <input
                                            type="checkbox"
                                            :id="`customCheckHide${item.id}`"
                                            v-model="item.checkHide"
                                            class="form-check-input"
                                        />
                                        <label
                                            :for="`customCheckHide${item.id}`"
                                            class="form-check-label d-inline"
                                        >
                                            Hide
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dataTables_paginate paging_simple_numbers float-end py-2" v-if="selectedCampus">
                            <ul class="pagination pagination-rounded mb-0">
                                <b-pagination
                                    v-model="selectedCampus.currentPage"
                                    :total-rows="duRows"
                                    :per-page="itemsPerPage"
                                    size="sm"
                                ></b-pagination>
                            </ul>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="py-5 my-5 text-center">
                        <p class="my-5 py-5">Select a campus to view its delivery units.</p>
                    </div>
                </template>
            </div>
            <div class="col-md-4">
                <div class="d-flex justify-content-between mb-2">
                    <p class="mb-0 text-white font-weight-bold font-size-18">
                        Department Access
                    </p>
                    <input 
                        v-if="selectedDU"
                        type="text" 
                        class="form-control form-control-sm w-auto" 
                        placeholder="Search Department..." 
                        v-model="selectedDU.search"
                    />
                </div>
                <template v-if="selectedDU">
                    <template v-if="selectedDU.loadingDepartments">
                        <div class="text-center my-5 py-5">
                            <div class="py-5 my-5">
                                <b-spinner variant="primary" label="Loading..."></b-spinner>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="ps-2" :class="{'border-bottom': selectedDU.departments.length > 15}">
                            <div v-for="item in filteredDepartments" :key="item.id" class="mb-1">
                                <div
                                    class="
                                        form-check form-checkbox-outline form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        :id="`customCheckcolor${item.id}`"
                                        v-model="item.checkMe"
                                        class="form-check-input"
                                    />
                                    <label
                                        :for="`customCheckcolor${item.id}`"
                                        class="form-check-label d-flex align-items-center"
                                    >
                                        <span>{{ item.departmentName }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="dataTables_paginate paging_simple_numbers float-end py-2" v-if="selectedDU.departments.length > 15">
                            <ul class="pagination pagination-rounded mb-0">
                                <b-pagination
                                    v-model="selectedDU.currentPage"
                                    :total-rows="departmentRows"
                                    :per-page="itemsPerPage"
                                    size="sm"
                                ></b-pagination>
                            </ul>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="py-5 my-5 text-center">
                        <p class="my-5 py-5">Select a delivery unit to view its departments.</p>
                    </div>
                </template>
            </div>
        </div>
        <div class="modal-footer">
            <button 
                type="button"
                class="btn btn-primary"
                @click="submitAccess"
            >Save Office Access</button>
            <button 
                type="button"
                class="btn btn-link"
                @click="$bvModal.hide('office-access-modal')"
            >Cancel</button>
        </div>
    </b-modal>
</template>